import { render, staticRenderFns } from "./TingXieJuZi.vue?vue&type=template&id=69671b6a&scoped=true"
import script from "./TingXieJuZi.vue?vue&type=script&lang=js"
export * from "./TingXieJuZi.vue?vue&type=script&lang=js"
import style0 from "./TingXieJuZi.vue?vue&type=style&index=0&id=69671b6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69671b6a",
  null
  
)

export default component.exports